var r="@hpstellar/core/currency-input";export{r as currencyInputTestId};
